<template>
    <app-content-admin>
        <template slot="header">Count Presta</template>
        <template>
            <v-row align="center">
                <v-col cols="10">
                    <v-text-field
                        v-model="searchTerm"
                        label="Ads Title"
                        outlined
                        clearable
                        solo-inverted
                        full-width
                    ></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-btn @click="adCountListData" class="ma-2">Search</v-btn>
                </v-col>
            </v-row>
        </template>

        <v-layout row wrap>
            <v-flex xs12>
                <v-card class="p-3">
                    <table class="table table-fluid no-wrap">
                        <thead>
                            <th scope="col">Ads Title</th>
                            <th scope="col">Display Count</th>
                            <th scope="col">Click Count</th>
                            <th scope="col">Ads Site</th>
                            <th scope="col">Ads Date</th>
                            <th scope="col">Site</th>
                        </thead>
                        <tbody>
                            <tr
                                class="text-center"
                                v-for="(adcount, i) in displayedItems"
                                :key="i"
                            >
                                <td :data-label="$t('Ads Title')">
                                    {{ adcount.ads_title }}
                                </td>
                                <td
                                    :data-label="$t('Display Count')"
                                    class="text-truncate"
                                >
                                    {{ adcount.display_count }}
                                </td>
                                <td
                                    :data-label="$t('Click Count')"
                                    class="text-truncate"
                                >
                                    {{ adcount.click_count }}
                                </td>
                                <td
                                    :data-label="$t('Ads Site')"
                                    class="text-truncate"
                                >
                                    {{ adcount.ads_site }}
                                </td>
                                <td
                                    :data-label="$t('Ads date')"
                                    class="text-truncate"
                                >
                                    {{ adcount.ads_date }}
                                </td>
                                <td :data-label="$t('Site')">
                                    {{ adcount.site }}
                                </td>
                         
                               
                            </tr>
                        </tbody>
                    </table>
                
                </v-card>
                <v-pagination
                    class="pagination mb-2"
                    v-model="currentPage"
                    :length="totalPages"
                    @input="updatePage"
                    :total-visible="7"
                ></v-pagination>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from "../../components/status/ActiveLabel.vue";
import store from "@/store";

export default {
    mixins: [vForm],

    data() {
        return {
            adcounts: [],
            form: {
                page: 1,
                offset: 10,
            },
            itemsPerPage: 10,
            currentPage: 1,
            searchTerm: "",
            searchResult: [],
        };
    },

    components: { ActiveLabel },

    computed: {
        totalPages() {
            return Math.ceil(this.adcounts.length / this.itemsPerPage);
        },
        displayedItems() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            console.log(endIndex);
            return this.adcounts.slice(startIndex, endIndex);
        },
    },

    created() {
        this.adCountListData();
        this.isRole = this.$store.getters["auth/role"];
    },

    methods: {
        //Pagination
        updatePage(page) {
            this.currentPage = page;
        },

        onListChange(page) {
            this.adCountListData(10, page);
        },

        //Read all adcount data
        adCountListData() {
            let loader = this.$loading.show();

            axios
                .get(`/api/auth/get_ad_count_presta_list`,{
                    params: {
                        search_term: this.searchTerm
                    }})
                .then((res) => res.data)
                .then((res) => {
                    this.adcounts = res.result;
                    console.log("Ad Count",this.adcounts);
                  
                })
                .catch((e) => {
                 //   this.$toastr.e(e.message);
                })
                .finally(() => {
                    loader.hide();
                });
        },


    },
};
</script>
